var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AttachmentListItem',{staticStyle:{"background":"transparent","border":"unset","max-width":"350px"},attrs:{"attachment":_vm.attachment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }